// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";
import Nestable from "react-nestable";

// Import components
import {NestableItem} from "../../components/cards/nestableItem";
import PageWrapper from "../../components/pageContentViews/pageWrapper";
import PageHeader from "../../components/pageContentViews/pageHeader";

// Import utils
import {mapStateToProps} from "../../redux/mapStateToProps";
import {deleteItem} from "../../utils/helperFunctions";
import {
    GetAboutSliders,
    DeleteAboutSliderById,
    UpdateAboutSlidersPositions
} from "../../redux/actions";


class AboutSlider extends Component {
    constructor(props) {
        super(props);
        this.deleteSlider = deleteItem.bind(this, props.DeleteAboutSliderById, 'սլայդերը');
        this.onPositionChange = this.onPositionChange.bind(this);
    }

    componentDidMount() {
        this.props.GetAboutSliders();
    }

    getNestableItems(list, parent = null) {
        const items = [];
        list && !!list.length && list.forEach((item, index) => {

            items.push({
                id: item.id,
                index: index,
                title: ' ',
                withImage: true,
                isHidden: item.isHidden,
                path: item?.mediaMain?.path,
                link: {
                    pathname: `about-slider/edit/${item.id}`,
                },
                deleteCb: () => this.deleteSlider(item.id),
                children: []
            })
        });
        return items;
    }

    async onPositionChange(items, item) {
        const movedSliderId = item.id;
        const {aboutSliderList} = this.props;
        const positionedItems = items.map((item, index) => {
            return {id: item.id, position: index}
        });
        if (~aboutSliderList.findIndex(m => m.id === movedSliderId) &&
            ~positionedItems.findIndex(m => m.id === movedSliderId)) {
            // first level slider was re-positioned in first level
            await this.props.UpdateAboutSlidersPositions(positionedItems);
            this.props.GetAboutSliders();
        }
    }

    render() {
        let {aboutSliderList} = this.props;
        let items = this.getNestableItems(aboutSliderList);
        return <PageWrapper pageTitle={'Մեր Մասին Սլայդեր'}>
            <PageHeader linkTitle={"Ավելացնել"}
                        addingLink={"/about-slider/add"}/>
            {items && items.length !== 0 &&
            <Nestable
                items={items}
                maxDepth={1}
                onChange={this.onPositionChange}
                renderItem={NestableItem}
            />}
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    GetAboutSliders,
    DeleteAboutSliderById,
    UpdateAboutSlidersPositions
};

export default connect(mapStateToProps, mapDispatchToProps)(AboutSlider);
